import { normalizeRecordings, getFilteredRecordingKeys } from '../Recordings/RecordingsUtils';
import { MAX_RANGE, MIN_RANGE, RecordingSource } from '../../Utils/Constants';
import { getDifference, getUnion, sortArrayBasedOnArray } from '../../Utils/ArrayUtils';
import {
  GET_ADMIN_RECORDINGS_FAILURE,
  GET_ADMIN_RECORDINGS_REQUEST,
  GET_ADMIN_RECORDINGS_SUCCESS,
  TOGGLE_ALL_ADMIN_RECORDINGS,
  TOGGLE_ADMIN_RECORDING,
  GET_RECORDING_CREATORS_REQUEST,
  GET_RECORDING_CREATORS_SUCCESS,
  GET_RECORDING_CREATORS_FAILURE,
  RESET_RECORDING_CREATORS_REQUEST
} from './AdminRecordingsActions';

const initialState = {
  fetching: false,
  filtering: false,
  creatorsFetching: false,
  recordings: {
    byKey: {},
    allKeys: [],
    deSelectedKeys: [],
    filteredKeys: [],
    filteredSelectedRecordingKeys: []
  },
  filter: {
    fromTime: null,
    toTime: null,
    searchString: '',
    sources: [RecordingSource.G2W, RecordingSource.G2S, RecordingSource.G2S_EMBEDDED],
    viewsRange: [MIN_RANGE, MAX_RANGE],
    sharesRange: [MIN_RANGE, MAX_RANGE],
    creators: []
  },
  pagination: {
    total: 0,
    limit: 0,
    page: 0,
    pageSize: 20
  },
  creators: {
    nextPage: null,
    page: 0,
    creators: [],
    filteredCreators: []
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_ADMIN_RECORDINGS_REQUEST: {
      return {
        ...state,
        filter: {
          ...state.filter,
          fromTime: action.payload.fromTime,
          toTime: action.payload.toTime
        },
        fetching: action.payload.loadPage,
        filtering: !action.payload.loadPage,
        error: null
      };
    }

    case GET_ADMIN_RECORDINGS_SUCCESS: {
      const recordingsList = action.payload.recordingsList;
      const { allKeys, byKey } = normalizeRecordings(recordingsList);
      const {
        viewsRange = state.filter.viewsRange,
        sharesRange = state.filter.sharesRange,
        fromTime = state.filter.fromTime,
        toTime = state.filter.toTime,
        sources = state.filter.sources,
        pagination
      } = action.payload;
      let recordings = state.recordings;
      const filteredKeys = getFilteredRecordingKeys(byKey, viewsRange, sharesRange, '', sources, allKeys);
      const newFilterDeSelectedRecordingKeys = getDifference(filteredKeys, recordings.filteredSelectedRecordingKeys);
      const newFilterDeSelectedRecordingKeysSecond = getDifference(filteredKeys, newFilterDeSelectedRecordingKeys);

      return {
        ...state,
        fetching: false,
        filtering: false,
        recordings: {
          ...state.filterRecordings,
          byKey,
          allKeys,
          filteredKeys: filteredKeys,
          deSelectedKeys: newFilterDeSelectedRecordingKeys,
          filteredSelectedRecordingKeys: newFilterDeSelectedRecordingKeysSecond
        },
        filter: {
          ...state.filter,
          fromTime,
          toTime
        },
        pagination
      };
    }

    case GET_ADMIN_RECORDINGS_FAILURE:
      return { ...state, fetching: false, error: action.error };

    case TOGGLE_ADMIN_RECORDING: {
      const { recordingKey, isSelected } = action.payload;
      const data = state.recordings;

      const { deSelectedKeys: existingDeSelectedKeys, allKeys, filteredKeys } = data;
      const newDeSelectedKeys = isSelected
        ? existingDeSelectedKeys.filter(key => key !== recordingKey)
        : sortArrayBasedOnArray([...existingDeSelectedKeys, recordingKey], allKeys);
      const newFilterSelectedRecordingKeys = getDifference(filteredKeys, newDeSelectedKeys);
      return {
        ...state,
        recordings: {
          ...state.recordings,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedRecordingKeys: newFilterSelectedRecordingKeys
        }
      };
    }

    case TOGGLE_ALL_ADMIN_RECORDINGS: {
      const data = state.recordings;

      const { deSelectedKeys: existingDeSelectedKeys, filteredKeys: existingFilteredKeys } = data;
      const newDeSelectedKeys = action.payload.isSelected
        ? getDifference(existingDeSelectedKeys, existingFilteredKeys)
        : getUnion(existingDeSelectedKeys, existingFilteredKeys);
      const newFilterSelectedRecordingKeys = getDifference(existingFilteredKeys, newDeSelectedKeys);

      return {
        ...state,
        recordings: {
          ...state.recordings,
          deSelectedKeys: newDeSelectedKeys,
          filteredSelectedRecordingKeys: newFilterSelectedRecordingKeys
        }
      };
    }
    case GET_RECORDING_CREATORS_REQUEST: {
      return {
        ...state,
        creatorsFetching: true,
        creators: action.payload.loadCreators
          ? { ...initialState.creators, filteredCreators: state.creators.filteredCreators }
          : state.creators
      };
    }
    case GET_RECORDING_CREATORS_SUCCESS: {
      const creators = [...state.creators.creators, ...action.payload.creators];
      return {
        ...state,
        creatorsFetching: false,
        creators: {
          ...state.creators,
          page: action.payload.page,
          nextPage: action.payload.nextPage,
          filteredCreators: action.payload.filter ? [...state.creators.filteredCreators] : creators,
          creators: creators
        }
      };
    }
    case GET_RECORDING_CREATORS_FAILURE:
      return { ...state, ...initialState, creatorsFetching: false, error: action.error };
    case RESET_RECORDING_CREATORS_REQUEST:
      return {
        ...state,
        creators: {
          ...state.creators,
          creators: [...state.creators.filteredCreators]
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/AdminRecordings/AdminRecordingsReducer.js